import React, { useEffect } from "react";

const RefundPolicy = () => {
  useEffect(() => {
    document.title = "CodeQueue - Refund & Cancellation Policy";
    window.scrollTo({ top: "0", behavior: "smooth" });
  });
  return (
    <div className="py-6 px md:px-16 lg:px-16 mt-16 mb-12">
      <h1 className="text-3xl font-bold mb-6">Refund & Cancellation Policy</h1>
      <p className="text-lg text-gray-600">Last updated: April 19, 2025</p>
      <p className="text-[17px] text-gray-600 mt-4">
        Thank you for choosing to book sessions with{" "}
        <span className="font-bold">CodeQueue</span>. We strive to ensure a
        valuable and seamless experience as you explore and engage with our
        services.
      </p>
      <p className="text-[17px] text-gray-600 mt-1">
        By booking a session on our platform, you acknowledge and agree to be
        bound by our Privacy Policy, Terms of Use, and this Refund Policy.
      </p>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          Service Pricing
        </h2>
        <p className="text-[17px] text-gray-600 ml-3">
          At CodeQueue, pricing is determined individually by each mentor based
          on the type and scope of the service offered—whether it's a mock
          interview, resume review, one-on-one mentorship, or career guidance.
          As a result, there is no fixed price range; costs may vary according
          to the mentor's discretion and service value.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          Payment Schedule
        </h2>
        <p className="text-[17px] text-gray-600 ml-3">
          Certain services may be time-bound and meant for specific durations.
          If applicable, the usage duration or service availability will be
          clearly mentioned in the service description. The payment remains
          valid until the stated service is delivered or the service window
          closes.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          Pricing Accuracy
        </h2>
        <p className="text-[17px] text-gray-600 ml-3">
          While we aim for complete accuracy in listing service prices,
          occasional errors may occur. If a discrepancy is found where the
          actual price is higher than listed, we reserve the right to cancel the
          affected order and inform the user accordingly.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          Refund Policy for Online Sessions
        </h2>
        <p className="text-[17px] text-gray-600 ml-3 font-semibold">
          Refunds for online sessions will be handled as follows:
        </p>
        <ol className="list-disc ml-8 text-[17px] text-gray-600">
            <li>If a mentor cancels the scheduled session or fails to attend, the mentee is eligible for a refund.</li>
            <li>In such cases, 98% of the total amount paid will be refunded to the mentee. A 2% processing fee will be deducted.</li>
            <li>No refunds will be granted for other reasons, unless explicitly approved by the CodeQueue support team.</li>
          </ol>
        <p className="text-[17px] text-gray-600 ml-3 mt-2 font-semibold">
        To request a refund under these circumstances, please:
        </p>
        <ol className="list-disc ml-8 text-[17px] text-gray-600">
          <li>Email us at <span className="font-bold">support@codequeue.in</span> with the subject line: "Session refund request | [Your Registered Email ID]"</li>
          <li>Provide a brief explanation for the refund request.</li>
          <li>Ensure the email is sent promptly after the session was missed or canceled by the mentor.</li>
        </ol>
        <p className="text-[17px] text-gray-600 ml-3 mt-2">
        Refunds will be processed within 3 working days from the time the refund request is reviewed and approved.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
        Refunds for Duplicate Payments
        </h2>
        <p className="text-[17px] text-gray-600 ml-3">
        In the event of a duplicate payment, the excess amount will be refunded to the original payment method. Processing will occur within 3 working days from the time the issue is reported and verified.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
        General Note on Refunds
        </h2>
        <p className="text-[17px] text-gray-600 ml-3">
        All approved refunds will be processed within 3 working days from the date of confirmation by <span className="font-bold">CodeQueue</span>. We are committed to providing timely support—feel free to contact our support team for any clarification or assistance.
        </p>
      </div>
    </div>
  );
};

export default RefundPolicy;
